/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import temperatureInputTemplate from './temperature-input.tpl.html';

/* eslint-enable import/no-unresolved, import/default */


export default angular.module('agrolog.components.temperatureInput', [])
    .directive('agTemperatureInput', TemperatureInput)
    .name;

/*@ngInject*/
function TemperatureInput($compile, $templateCache, unitService) {

    var linker = function (scope, element, attrs, ngModelCtrl) {
        var template = $templateCache.get(temperatureInputTemplate);
        element.html(template);

        scope.$watch('agMin', (newValue) => {
            if (angular.isDefined(newValue)) {
                scope.agTempMin = unitService.toUserTemperature(newValue + 0.01, scope.absolute);
            }
        });

        scope.$watch('agMax', (newValue) => {
            if (angular.isDefined(newValue)) {
                scope.agTempMax = unitService.toUserTemperature(newValue - 0.01, scope.absolute);
            }
        });

        scope.fieldName = 'temperature' + Math.random() * 1000;

        scope.tempSymbol = unitService.temperatureUnitSymbol();

        scope.agError = angular.isDefined(scope.agRequired) || angular.isDefined(scope.agMin) || angular.isDefined(scope.agMax);
        
        scope.updateView = function () {
            if (!scope.disabled) {
                ngModelCtrl.$setViewValue(unitService.fromUserTemperature(scope.temperature, scope.absolute));
            }
        };

        ngModelCtrl.$render = function () {
            if (ngModelCtrl.$viewValue) {
                scope.temperature = unitService.toUserTemperature(ngModelCtrl.$viewValue, scope.absolute);
            } else {
                scope.temperature = null;
            }
        };

        scope.$watch('temperature', function () {
            scope.updateView();
        });

        scope.$watch('disabled', function () {
            scope.updateView();
        });

        $compile(element.contents())(scope);

    }

    return {
        restrict: "E",
        require: "^ngModel",
        link: linker,
        scope: {
            label: '@',
            requiredText: '@',
            minText: '@',
            maxText: '@',
            agRequired: '=?',
            agMin: '=?',
            agMax: '=?',
            disabled:'=ngDisabled',
            theForm: '=?',
            absolute: '=?'
        }
    };
}
